// extracted by mini-css-extract-plugin
export default {"container":"listen_container__6otVp","head":"listen_head__laUVy","firstAblum":"listen_firstAblum__+A1al","secondAlbum":"listen_secondAlbum__ifvuW"};